/**
 * Task PG: Owner Payroll grouped navigation (left menu on desktop / tablet, list → sub-page on phones) + search.
 * One row per key: [key, English, 中文] — English + 中文 only (ms falls back to English). Registered in ../modules.ts.
 */
const ROWS = [
  ["pg.sub", "Base salary + commission, approved monthly.", "底薪 + 提成，每月审批。"],
  ["pg.search", "Search payroll", "搜索工资"],
  ["pg.noResults", "Nothing matches.", "没有匹配的项目。"],
  ["pg.back", "All", "全部"],
  ["pg.g.run", "Pay run", "发薪"],
  ["pg.g.comp", "Salary & commission", "薪资与提成"],
  ["pg.g.time", "Attendance", "考勤"],
  ["pg.g.money", "Claims & bank", "报销与银行"],
  ["pg.g.setup", "Setup", "设置"],
  ["pg.item.attendance", "Clock-in records", "打卡记录"],
  ["pg.item.settings", "Payroll settings", "工资设置"],
] as const;

export type PgKey = (typeof ROWS)[number][0];
const col = (i: 1 | 2) => Object.fromEntries(ROWS.map((r) => [r[0], r[i]])) as Record<PgKey, string>;

export const taskPG = { en: col(1), zh: col(2), ms: col(1) };
